var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/brush2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8095 3.94C20.2695 7.78 16.4095 13 13.1795 15.59L11.2095 17.17C10.9595 17.35 10.7095 17.51 10.4295 17.62C10.4295 17.44 10.4195 17.24 10.3895 17.05C10.2795 16.21 9.89953 15.43 9.22953 14.76C8.54953 14.08 7.71953 13.68 6.86953 13.57C6.66953 13.56 6.46953 13.54 6.26953 13.56C6.37953 13.25 6.54953 12.96 6.75953 12.72L8.31953 10.75C10.8995 7.52 16.1395 3.64 19.9695 2.11C20.5595 1.89 21.1295 2.05 21.4895 2.42C21.8695 2.79 22.0495 3.36 21.8095 3.94Z",
    stroke: "#4B4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.2403 14.47C14.2403 11.86 12.1203 9.74001 9.51027 9.74001M10.4303 17.62C10.4303 18.72 10.0103 19.77 9.22027 20.57C8.61027 21.18 7.78027 21.6 6.79027 21.73L4.33027 22C2.99027 22.15 1.84027 21.01 2.00027 19.65L2.27027 17.19C2.51027 15 4.34027 13.6 6.28027 13.56C6.48027 13.55 6.69027 13.56 6.88027 13.57C7.73027 13.68 8.56027 14.07 9.24027 14.76C9.91027 15.43 10.2903 16.21 10.4003 17.05C10.4103 17.24 10.4303 17.43 10.4303 17.62Z",
    stroke: "#4B4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.4a95cea2daa07c38dc854e25ebfa17fc.svg";
export { ForwardRef as ReactComponent };